// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

// Reuse a single consumer across Turbo visits
if (!window.ActionCableConsumer) {
  window.ActionCableConsumer = createConsumer()
  try { console.debug("ActionCable consumer created (singleton)") } catch(_) {}
}

export default window.ActionCableConsumer
